// Mobile accordion behavior
document.addEventListener('DOMContentLoaded', function() {
  var accordionToggles = document.querySelectorAll('.syb-footer [data-accordion-toggle]');

  accordionToggles.forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      if (window.innerWidth < 750) {
        var column = this.closest('[data-accordion]');
        column.classList.toggle('is-open');
      }
    });
  });
});

// Load Klaviyo script if not already loaded (fallback for when app embed is disabled)
setTimeout(function() {
  if (!window.klaviyo && !document.querySelector('script[src*="klaviyo"]')) {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=VsSiEY';
    document.head.appendChild(script);
  }
}, 1000);

// Hide newsletter section if Klaviyo form doesn't render (visitor already on list)
(function() {
  var checkCount = 0;
  var maxChecks = 10;

  function checkKlaviyoForm() {
    checkCount++;
    var newsletterSection = document.querySelector('.syb-footer__newsletter');
    var formContainer = document.querySelector('.syb-footer__newsletter-form');

    if (!newsletterSection || !formContainer) return;

    var hasForm = formContainer.querySelector('form, input, button, iframe');
    var hasHeight = formContainer.offsetHeight > 50;

    if (hasForm || hasHeight) {
      return;
    }

    if (checkCount >= maxChecks) {
      newsletterSection.classList.add('is-hidden');
    } else {
      setTimeout(checkKlaviyoForm, 500);
    }
  }

  setTimeout(checkKlaviyoForm, 2000);
})();
